// Import: Middleware Action & Custom Types
import { CHANGE_ZONE_CLEAN, CHANGE_ZONE_CLEAN_ERROR } from '_models/redux/types';

// Action function
export const cleanChangeZone = () => async (dispatch) => {
  // Endpoint: Try & Catch

  try {
    dispatch({
      type: CHANGE_ZONE_CLEAN,
      payload: [],
    });
  } catch (e) {
    dispatch({
      type: CHANGE_ZONE_CLEAN_ERROR,
      payload: [],
    });
  }
};
